/**
 * Metaobject condition checking utilities
 * Validates whether metaobjects should display based on user scope, date, tag, product, and collection criteria
 */

import { Criteria, BaseObject } from './metaobjects.types'
import { globalState } from './utils'

export function checkConditions(conditions: BaseObject, criteria: Criteria): boolean {
  const { tags = [], products = [], collections = [] } = criteria

  if (conditions?.user_scope && conditions.user_scope !== 'Show to All') {
    const customerId = globalState?.customer?.id
    const isB2B = globalState?.customer?.b2b || false
    const userScope = conditions.user_scope

    if (!customerId && userScope === 'Customer') {
      return false
    }

    if (customerId && userScope === 'Non Customer') {
      return false
    }

    if ((!customerId || !isB2B) && userScope === 'B2B Customer') {
      return false
    }

    if (isB2B && userScope === 'Non B2B Customer') {
      return false
    }
  }

  if (conditions?.available_countries && conditions.available_countries.length > 0) {
    const currentCountry = globalState?.localization?.country
    if (!currentCountry || !conditions.available_countries.some((c) => c.country_code === currentCountry)) {
      return false
    }
  }

  const now = Date.now()

  if (conditions?.start_date && conditions.start_date.trim() !== '') {
    const startDate = new Date(conditions.start_date)
    if (!isNaN(startDate.getTime()) && now < startDate.getTime()) {
      return false
    }
  }

  if (conditions?.end_date && conditions.end_date.trim() !== '') {
    const endDate = new Date(conditions.end_date)
    if (!isNaN(endDate.getTime()) && now >= endDate.getTime()) {
      return false
    }
  }

  const hasTagConditions = conditions?.tags && conditions.tags.length > 0
  const hasProductConditions = conditions?.products && conditions.products.length > 0
  const hasCollectionConditions = conditions?.collections && conditions.collections.length > 0

  if (!hasTagConditions && !hasProductConditions && !hasCollectionConditions) {
    return false
  }

  let hasMatch = false

  if (hasCollectionConditions && conditions.collections) {
    const collectionMatch = conditions.collections.some((conditionCollection) =>
      collections.some((criteriaCollection) => conditionCollection === criteriaCollection)
    )
    if (collectionMatch) hasMatch = true
  }

  if (hasProductConditions && conditions.products) {
    const productMatch = conditions.products.some((conditionProduct) =>
      products.some((criteriaProduct) => conditionProduct === criteriaProduct)
    )
    if (productMatch) hasMatch = true
  }

  if (hasTagConditions && conditions.tags) {
    const tagMatch = conditions.tags.some((conditionTag) => tags.some((criteriaTag) => conditionTag === criteriaTag))
    if (tagMatch) hasMatch = true
  }

  return hasMatch
}
